import { format, isValid, parseISO } from "date-fns";
import countries from "i18n-iso-countries";
import fr from "i18n-iso-countries/langs/fr.json";

countries.registerLocale(fr);

export const COUNTRY_OPTIONS = Object.entries(countries.getNames("fr"))
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const getDateInputValue = (value) => {
  if (!value) return "";

  if (typeof value === "string") {
    const normalized = value.trim();
    const dateMatch = normalized.match(/^(\d{4}-\d{2}-\d{2})/);
    if (dateMatch?.[1]) return dateMatch[1];

    const parsed = parseISO(normalized);
    return isValid(parsed) ? format(parsed, "yyyy-MM-dd") : "";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().slice(0, 10);
};
